import { render } from "./ContactsClients.vue?vue&type=template&id=58f164fd&scoped=true"
import script from "./ContactsClients.vue?vue&type=script&lang=js"
export * from "./ContactsClients.vue?vue&type=script&lang=js"

import "./ContactsClients.vue?vue&type=style&index=0&id=58f164fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f164fd"]])

export default __exports__